module.exports = __webpack_public_path__ + "img/pamphlet_thumb03@3x.03b7d31a.png";